import _ from "lodash"
import React, { useState, useCallback, useEffect, useRef } from "react"
import MovieList from "./MovieList"
import { fetchMoviesByName } from "../services/movieService"
import {
  saveSearchState,
  loadSearchState,
} from "../services/localStorageHelper"
import "./SearchMovies.css"
import "../layout/button.css"

const SearchMovies = () => {
  const [query, setQuery] = useState("")
  const [movieList, setMovieList] = useState([])
  const [page, setPage] = useState(1)
  const [totalResults, setTotalResults] = useState(0)

  const [loadingMore, setLoadingMore] = useState(false)

  // useRef: valor mutável que não provoca re-render
  const movieListRef = useRef(movieList)
  movieListRef.current = movieList
  const loadingRef = useRef(false)

  const fetchMoviesInSearch = useCallback(async (currentQuery, currentPage, currentList) => {
    try {
      loadingRef.current = true
      setLoadingMore(true)
      const response = await fetchMoviesByName(currentQuery, currentPage, 20)
      const newMovies = response.movies || []
      const combined = [...currentList, ...newMovies]
      const unique = Array.from(new Map(combined.map((m) => [m.id, m])).values())
      setMovieList(unique)
      setTotalResults(response.totalResults || 0)
      saveSearchState(currentQuery, unique, currentPage, response.totalResults || 0)
    } catch (error) {
      console.error("Error fetching movies:", error)
    } finally {
      loadingRef.current = false
      setLoadingMore(false)
    }
  }, [])

  const debouncedFetch = useCallback(
    _.debounce((q) => {
      fetchMoviesInSearch(q, 1, [])
    }, 300),
    [fetchMoviesInSearch]
  )

  useEffect(() => {
    const savedState = loadSearchState()
    if (savedState) {
      setQuery(savedState.query)
      setMovieList(savedState.movieList)
      setPage(savedState.page)
      setTotalResults(savedState.totalResults)
    }
  }, [])

  useEffect(() => {
    window.onbeforeunload = () => localStorage.clear()
  }, [])

  const handleSearch = (e) => {
    const value = e.target.value
    setQuery(value)
    setMovieList([])
    setPage(1)
    setTotalResults(0)
    if (value) debouncedFetch(value)
  }

  const loadMoreMovies = () => {
    if (loadingRef.current) return
    const nextPage = page + 1
    setPage(nextPage)
    fetchMoviesInSearch(query, nextPage, movieListRef.current)
  }

  const searched = query.trim().length > 0 || movieList.length > 0

  return (
    <div className={`search-stage ${searched ? "search-stage--searched" : ""}`}>
      <header className="search-hero">
        <h1 className="search-hero__title">iFelt</h1>
        <p className="search-hero__tagline">Cinema, sorted by the emotions it stirs.</p>
        <div className="search-field">
          <input
            type="text"
            placeholder="Search for a movie"
            value={query}
            onChange={handleSearch}
            autoFocus
          />
          <span className="search-field__rule" />
        </div>
      </header>

      <div className="movie-search-return">
        <MovieList movieList={movieList} />
        {movieList.length < totalResults && (
          <button
            className="ifelt-button button-center"
            onClick={loadMoreMovies}
            disabled={loadingMore}
          >
            {loadingMore ? "Loading…" : "Load More"}
          </button>
        )}
      </div>
    </div>
  )
}

export default SearchMovies
